import { CloseOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, DatePicker, Form, Input, Modal, Select, TreeSelect, TreeSelectProps } from "antd";

import viVN from 'antd/locale/vi_VN';

import { FormProps } from "antd/lib";
import dayjs from "dayjs";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { addCustomerComplaint } from "../../../../../../api/Customer_V2/customerApi_V2";
import { Category, getCLCarLines, getCLCategoryCar, getCLComplaintCategories, getListRegion, getSLBrandsByCustomer, getSLCarLinesByCustomer, getSLCarsByCarLineIdAndCategoryCarId, getSLVehicleChassisNumbers, getSLVehiclePlateNumbers, IComplaintCategories, } from "../../../../../../api/selectOption/selectOptionsApi";
import { ISelectOption } from "../../../../../../api/selectOptions/selectOptionsApi";
import useDebounce from "../../../../../../hook/useDebounce";
import useLoading from "../../../../../../hook/useLoading";
import useToast from "../../../../../../hook/useToast";
import { datachanelFbName, datachanelFbNameIPCC, dataComplainNameTreeDDMS, dataComplainNameTreeIPCC, dataDocResultName, dataDocStatusEndName, dataInteractionCategory, dataInteractionType, dataProcessLevel } from "../../../../../../services/data";
import { selectorInfoUser } from "../../../../../../store/slices/infoUserSlice";
import { selectorUnitByUserPermission } from "../../../../../../store/slices/UnitByUserPermission";
import { convertToAntdOptions, convertToAntdOptionsV2, fommatSelectOption, fommatSelectOptionToUpperCase, fommatSelectOptionUnitByUser } from "../../../../../../until";
import '../../../../styles.scss';
import { getInfoCarCustomer } from "../../../../../../api/car/carApi";
import { DataNode } from "antd/es/tree";

export const findNode = (data: any[], value: string): any | null => {
  for (const node of data) {
    if (node.value === value) return node;
    if (node.children) {
      const found = findNode(node.children, value);
      if (found) return found;
    }
  }
  return null;
};


type TreeNode = NonNullable<TreeSelectProps["treeData"]>[number];

export const convertBrandToTreeSelect = (
  data: IComplaintCategories[] = []
): TreeNode[] => {
  const convertChildren = (items: Category[]): TreeNode[] =>
    [...items]
      .sort((a, b) => (a.orderNumber ?? 0) - (b.orderNumber ?? 0))
      .map((item) => ({
        title: item.title,
        label: item.title,
        value: item.value,
        key: item.value,
        children: item.children?.length
          ? convertChildren(item.children)
          : undefined,
      }));

  return data.map((item) => ({
    title: item.brand,
    label: item.brand,
    value: item.value,
    key: item.value,
    children: convertChildren(item.categories ?? []),
  }));
};



export const convertCategoriesToTreeSelect = (
  data: IComplaintCategories[] = []
): TreeNode[] => {
  const convertChildren = (items: Category[]): TreeNode[] =>
    [...items]
      .sort((a, b) => (a.orderNumber ?? 0) - (b.orderNumber ?? 0))
      .map((item) => ({
        title: item.title,
        label: item.title,
        value: item.value,
        key: item.value,
        children: item.children?.length
          ? convertChildren(item.children)
          : undefined,
      }));

  return data.flatMap((item) =>
    convertChildren(item.categories ?? [])
  );
};

// Chuyển đường dẫn value thành label/label

// interface CustomDataNode extends DataNode {
//   value: string;
//   label?: string;
//   displayLabel?: string;
//   children?: CustomDataNode[];
// }

export const convertTreeLabels = (
  data: TreeNode[],
  parentLabels: string[] = []
): TreeNode[] => {
  return data.map((node) => {
    const currentLabel = String(
      node.label ?? node.title ?? ""
    );

    const labels = [...parentLabels, currentLabel];

    return {
      ...node,
      label: labels.join(" / "),
      title: currentLabel,
      displayLabel: currentLabel,
      selectable: !node.children?.length,
      children: node.children?.length
        ? convertTreeLabels(node.children, labels)
        : undefined,
    };
  });
};

const { TextArea } = Input;
interface ModalProps {
  isOpen: boolean
  idCustomer?: number
  resultFormSubmit?: (iSsuccess: boolean, message?: string) => void
  closeModal: (isOpen: boolean) => void
}
const ModalAddSupportHistoryV2: React.FC<ModalProps> = ({
  isOpen, idCustomer,
  resultFormSubmit, closeModal
}) => {
  const pushToast = useToast()
  const pushLoading = useLoading()
  const { id, username, unit } = useSelector(selectorInfoUser)
  const unitByUserPermissionSlice = useSelector(selectorUnitByUserPermission)

  const [form] = Form.useForm();
  const chanelFbName = Form.useWatch("chanelFbName", form);//kênh tiếp nhận
  const docDate = Form.useWatch("docDate", form); // ngày ghi nhận
  //
  const carLineId = Form.useWatch("carLineId", form); // dòng xe
  const categoryCarId = Form.useWatch("categoryCarId", form); // thương hiệu
  const vehicleId = Form.useWatch("vehicleId", form); // tên xe
  const docCode = Form.useWatch("docCode", form); // Loại tương tác


  const [sLCarLines, setSLCarLines] = useState<ISelectOption[]>([])
  const [sLCategoryCar, setSLCategoryCar] = useState<ISelectOption[]>([])
  const [sLCar, setSLCar] = useState<any[]>([])
  const [carId, setCarId] = useState<number>()
  const [plateNumberId, setPlateNumberId] = useState<number>()
  const [sLChassisNo, setSLChassisNo] = useState<ISelectOption[]>([])
  const [sLAdminId, setSLAdminId] = useState<ISelectOption[]>([{ value: id, label: username }])
  const [sLBranchId, setSLBranchId] = useState<ISelectOption[]>([])
  const [sLComplaintCategories, setSLComplaintCategories] = useState<TreeNode[]>([])
  const [sLRegionId, setSLRegionId] = useState<ISelectOption[]>([])
  const [searchCar, setSearchCar] = useState<string>('')


  //#region gọi api SL OP
  // const gSLCarLines = async () => {
  //     const result = await getCLCarLines()
  //     if (result?.status) {
  //         setSLCarLines(fommatSelectOption(result.data))
  //     }
  // }

  const gCLComplaintCategories = async () => {
    // form.setFieldValue("complainName", undefined); //rs Phân loại
    if (!docCode) return
    const type = docCode === "Khác" ? 1 : 0
    if (type === 1) {
      if (!categoryCarId) return
    }
    const result = await getCLComplaintCategories(type, categoryCarId)
    if (result?.status) {
      type === 1 ?
        setSLComplaintCategories(convertBrandToTreeSelect(result.data))
        :
        setSLComplaintCategories(convertCategoriesToTreeSelect(result.data))
    }
  }


  const gSLCarLinesByCustomer = async () => {
    if (!idCustomer) return
    const result = await getSLCarLinesByCustomer(idCustomer)
    if (result?.status) {
      setSLCarLines(fommatSelectOption(result.data))
    }
  }

  const gCLCategoryCar = async () => {
    if (!idCustomer) return
    if (!carLineId) {
      setSLCategoryCar([])
      return
    }
    const result = await getSLBrandsByCustomer(
      idCustomer, carLineId
    )
    if (result?.status) {
      setSLCategoryCar(fommatSelectOption(result.data))
    }
  }

  const gSLCarsByCarLineIdAndCategoryCarId = useDebounce(async () => {
    if (!idCustomer) return

    if (!carLineId || !categoryCarId) {
      setSLCar([])
      return
    }
    const result = await getSLCarsByCarLineIdAndCategoryCarId(
      idCustomer, carLineId, categoryCarId, searchCar
    )
    if (result?.status) {
      setSLCar(convertToAntdOptions(result.data))

      const allChildren = result?.data?.flatMap(g => g.children || []) || [];
      if (allChildren.length === 1) {
        form.setFieldValue("vehicleId", allChildren[0].vehicleId); //rs tên xe
      }
    }
  }, 1000)

  const gInfoCarCustomer = useDebounce(async () => {
    if (!idCustomer || !vehicleId) return
    const result = await getInfoCarCustomer(
      vehicleId, idCustomer
    )
    if (result?.status) {
      const { plateNumber, plateNumberId, vehicleChassisNo } = result.data
      setSLChassisNo(fommatSelectOptionToUpperCase(vehicleChassisNo))
      form.setFieldValue("numberPlateId", plateNumber);
      setPlateNumberId(plateNumberId)
      if (vehicleChassisNo.length === 1)
        form.setFieldValue("chassisNo", vehicleChassisNo[0].id);
    }
  }, 1000)

  const gSLBranchId = async () => {
    setSLBranchId(fommatSelectOptionUnitByUser(unitByUserPermissionSlice))
  }

  const getSLRegionId = async () => {
    const result = await getListRegion()
    if (result?.status) {
      setSLRegionId(fommatSelectOption(result.data))
    } else {
      //   pushToats(result?.message, "warning")
    }
  }




  //#endregion

  const submitForm = () => {
    if (form) {
      form.submit();
    }
  };
  const onFinish: FormProps["onFinish"] = async (values) => {
    if (!idCustomer) return
    pushLoading(true)
    const {
      docCode, chanelFbName, docDate,
      interactionCategory, docDateEndProc, docStatusEndName, docResultName,
      vehicleId, chassisNo, complainName,
      adminId, branchId, regionId,
      processLevel, complainDesc, solution, note,
      suspendReason, nextProcessDate
    } = values

    // export const dataInteractionType = [
    //   { value: "F3", label: "Khiếu nại" },
    //   { value: "F2", label: "Phàn nàn" },
    //   { value: "Khác", label: "Khác" },
    // ]

    const type = docCode === "Khác" ? 1 : 0

    const validDocDate = docDate ? docDate?.format('YYYY/MM/DD') : undefined
    const validDocDateEndProc = docDateEndProc ? docDateEndProc?.format('YYYY/MM/DD') : undefined
    const validNextProcessDate = nextProcessDate ? nextProcessDate?.format('YYYY/MM/DD') : undefined
    // const carIdTmp = carId ? carId : undefined

    const result = await addCustomerComplaint(
      idCustomer, docCode, chanelFbName, validDocDate,
      interactionCategory, validDocDateEndProc, docStatusEndName, docResultName,
      carId, vehicleId, plateNumberId, chassisNo, complainName,
      adminId, branchId, regionId,
      processLevel, complainDesc, solution, note,
      suspendReason, validNextProcessDate, type

    )
    if (result?.status) {
      resultFormSubmit?.(true, result?.message)
    } else {
      resultFormSubmit?.(false, result?.message)
    }
    pushLoading(false)

  }



  //#region Thay đổi form rs

  useEffect(() => {
    if (isOpen) {
      //rs khi thay đổi kênh tiếp nhận
      form.setFieldValue("complainName", undefined)
    }

  }, [chanelFbName])

  useEffect(() => {
    if (!isOpen) return

    gCLCategoryCar()
    // if (isProgrammaticCarLineSet.current) {
    //   isProgrammaticCarLineSet.current = false;
    //   return;
    // }
    if (isOpen) {
      form.setFieldValue("categoryCarId", undefined); //rs thương hiệu
      form.setFieldValue("vehicleId", undefined); //rs tên xe
      form.setFieldValue("numberPlateId", undefined); //rs biển số
      form.setFieldValue("chassisNo", undefined); //rs số khung
    }
  }, [carLineId]);

  useEffect(() => {
    if (!isOpen) return

    gSLCarsByCarLineIdAndCategoryCarId()
    // if (isProgrammaticCarLineSet.current) {
    //   isProgrammaticCarLineSet.current = false;
    //   return;
    // }
    if (isOpen) {
      form.setFieldValue("complainName", undefined); //rs Phân loại
      form.setFieldValue("vehicleId", undefined); //rs tên xe
      form.setFieldValue("numberPlateId", undefined); //rs biển số
      form.setFieldValue("chassisNo", undefined); //rs số khung
    }
  }, [categoryCarId]);

  useEffect(() => {
    if (!isOpen) return

    if (vehicleId) {
      gInfoCarCustomer()
    } else {
      form.setFieldsValue({
        "numberPlateId": undefined,
        "chassisNo": undefined,
      })

      setSLChassisNo([])
    }
    // if (isProgrammaticCarLineSet.current) {
    //   isProgrammaticCarLineSet.current = false;
    //   return;
    // }
    if (isOpen) {
      form.setFieldValue("numberPlateId", undefined); //rs biển số
      form.setFieldValue("chassisNo", undefined); //rs số khung
    }
  }, [vehicleId]);

  useEffect(() => {
    gCLComplaintCategories()
  }, [docCode, categoryCarId])



  //#endregion

  useEffect(() => {
    gSLCarsByCarLineIdAndCategoryCarId()
  }, [searchCar])

  useEffect(() => {
    if (isOpen) {
      if (!sLCarLines.length)
        gSLCarLinesByCustomer()
      if (!sLBranchId.length)
        gSLBranchId()
      if (!sLRegionId.length)
        getSLRegionId()

      form.setFieldsValue({
        docDate: dayjs(),
        adminId: id,
        branchId: unit
      });


    } else {
      form.resetFields()
    }

  }, [isOpen])

  const treeDataDisplay = useMemo(() => {
    return convertTreeLabels(sLComplaintCategories ?? []);
  }, [sLComplaintCategories]);
  return (

    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="custom-page-css flex flex-col  gap-2"

    >
      <ConfigProvider locale={viVN}>
        <Modal
          title={<div className="bg-FCFCFD d-flex justify-betweeen align-center pb-4  w-full border-b-F0F0F0 rounded-2 overflow-hidden">
            <span className="text-base text-344054 fw-500 font-medium">Tạo thông tin hỗ trợ, khiếu nại</span>
            <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
          </div>}
          open={isOpen}
          onCancel={() => closeModal(false)}
          centered
          className=" custom-modal-ant-history"
          destroyOnClose
          closeIcon={false}
          footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center pt-2  w-full border-t-F0F0F0">
            <div className="custom-page-css w-full flex justify-end gap-2 mt-4">
              <Button onClick={() => closeModal(false)}>Huỷ</Button>
              <Button
                type="primary"
                onClick={submitForm}
              >Lưu</Button>
            </div>
          </div>}
        >
          <div className="custom-modal-ant-history-child custom-page-css flex flex-col max-h-65vh overflow-y-scroll gap-2 py-2">
            <span className="text-base text-344054 fw-500 font-medium">Thông tin chung</span>

            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                label={<span>
                  Loại tương tác <span className="text-FF1D1D">*</span>:
                </span>}
                name="docCode"
                layout="vertical"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn loại tương tác"
                  }
                ]}
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Loại tương tác"
                  // options={dataInteractionCategory_V2}
                  options={dataInteractionType}
                  onChange={() => {
                    form.setFieldValue("complainName", undefined);
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Phân loại liên hệ:"
                name="interactionCategory"
                layout="vertical"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Phân loại liên hệ"
                  options={dataInteractionCategory}
                />
              </Form.Item>
            </div>
            {/* Row 1 */}
            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                label={
                  <span>Ngày ghi nhận <span className="text-FF1D1D">*</span>:</span>
                }
                name="docDate"
                layout="vertical"
                rules={[
                  {
                    required: true,
                    message: 'Vui lòng chọn ngày ghi nhận',
                  },
                ]}
              >
                <DatePicker
                  className="w-full custom-input-date"
                  format="DD/MM/YYYY"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span>Kênh tiếp nhận <span className="text-FF1D1D">*</span>:</span>
                }
                name="chanelFbName"
                layout="vertical"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn kênh tiếp nhận"
                  }
                ]}
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Kênh tiếp nhận"
                  disabled={!docCode}
                  options={docCode === 'Khác' ? datachanelFbNameIPCC : datachanelFbName}
                />
              </Form.Item>
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-2 gap-4">

              <Form.Item
                label="Ngày kết thúc:"
                name="docDateEndProc"
                layout="vertical"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || !docDate) {
                        return Promise.resolve();
                      }

                      if (value.isSame(docDate, "day") || value.isAfter(docDate, "day")) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        new Error("Ngày kết thúc phải lớn hơn hoặc bằng ngày ghi nhận")
                      );
                    }
                  })
                ]}
              >
                <DatePicker
                  className="w-full custom-input-date"
                  format="DD/MM/YYYY"
                  disabled={!docDate}
                />
              </Form.Item>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                label="Trạng thái kết thúc xử lý"
                name="docStatusEndName"
                layout="vertical"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Trạng thái kết thúc xử lý"
                  options={dataDocStatusEndName}
                />
              </Form.Item>

              <Form.Item
                label="Kết quả sau xử lý:"
                name="docResultName"
                layout="vertical"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Kênh tiếp nhận"
                  options={dataDocResultName}
                />
              </Form.Item>
            </div>
            <span className="text-base text-344054 fw-500 font-medium pt-2">Thông tin xe</span>
            {/* Row 3 */}
            <div className="grid grid-cols-2 gap-4">
              <div className="grid grid-cols-2 gap-4">
                <Form.Item
                  label="Dòng xe:"
                  name="carLineId"
                  layout="vertical"
                >
                  <Select
                    className="custom-page-css border rounded"
                    placeholder="Dòng xe"
                    options={sLCarLines}
                  />
                </Form.Item>
                <Form.Item
                  label="Thương hiệu:"
                  name="categoryCarId"
                  layout="vertical"
                >
                  <Select
                    className="custom-page-css border rounded"
                    placeholder="Thương hiệu"
                    disabled={!carLineId}
                    options={sLCategoryCar}
                    onChange={() => {
                      form.setFieldValue("complainName", undefined);
                    }}

                  />
                </Form.Item>
              </div>

              <Form.Item
                layout="vertical"
                label={<span>
                  Tên xe <span className="text-FF1D1D">*</span>:
                </span>}
                name="vehicleId"
                rules={[
                  { required: true, message: "Vui lòng chọn tên xe" },
                ]}
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Tên xe"
                  showSearch
                  searchValue={searchCar}
                  onSearch={(e) => setSearchCar(e)}
                  onChange={(value, option: any) => {
                    setCarId(option?.carId)
                  }}
                  filterOption={false}
                  disabled={!categoryCarId}
                  allowClear
                  options={sLCar}

                />

              </Form.Item>
            </div>


            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                label="Biển số xe:"
                name="numberPlateId"
                layout="vertical"
              >
                <Input
                  className="custom-input-css custom-page-css border"
                  placeholder="Biển số xe"
                  disabled
                // options={sLnumberPlateId}
                />
              </Form.Item>

              <Form.Item
                label="Số khung:"
                name="chassisNo"
                layout="vertical"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Số khung"
                  disabled={!vehicleId}
                  options={sLChassisNo}
                />
              </Form.Item>
            </div>
            <span className="text-base text-344054 fw-500 font-medium pt-2">Thông tin hỗ trợ, khiếu nại</span>

            {/* Row 4 */}
            <div className="grid  gap-4">
              <Form.Item
                label="Phân loại:"
                name="complainName"
                layout="vertical"
              >
                {/* {
                  chanelFbName?.includes('IPCC') ?
                    <TreeSelect
                      className="custom-page-css border rounded"
                      style={{ width: '100%' }}
                      styles={{
                        popup: {
                          root: { maxHeight: 400, overflow: 'auto' },
                        },
                      }}
                      placeholder="Phân loại"
                      treeData={sLComplaintCategories}
                      disabled={!chanelFbName}
                      treeNodeLabelProp="value"
                      tagRender={(props) => {
                        const node = findNode(sLComplaintCategories, props.value as string);
                        return (
                          <span>
                            {node?.value || props.value}
                          </span>
                        );
                      }}
                    /> : */}
                {/* <TreeSelect
                  className="custom-page-css border rounded"
                  style={{ width: '100%' }}
                  styles={{
                    popup: {
                      root: { maxHeight: 400, overflow: 'auto' },
                    },
                  }}
                  placeholder="Phân loại"
                  treeData={sLComplaintCategories}
                  disabled={
                    // !chanelFbName
                    (docCode === "Khác" && !categoryCarId) || !docCode

                  }
                  treeNodeLabelProp="value"
                  tagRender={(props) => {
                    const node = findNode(sLComplaintCategories, props.label as string);
                    return (
                      <span>
                        {node?.label || props.label}
                      </span>
                    );
                  }}
                /> */}

                <TreeSelect
                  className="custom-page-css border rounded"
                  style={{ width: "100%" }}
                  showSearch
                  styles={{
                    popup: {
                      root: { maxHeight: 400, overflow: "auto" },
                    },
                  }}
                  placeholder="Phân loại"
                  treeData={treeDataDisplay}
                  disabled={(docCode === "Khác" && !categoryCarId) || !docCode}
                  treeNodeLabelProp="label"
                />


                {/* } */}
              </Form.Item>


            </div>

            {/* Row 5 */}
            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                label="Nhân viên tiếp nhận:"
                name="adminId"
                layout="vertical"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Nhân viên tiếp nhận"
                  options={sLAdminId}
                  disabled
                />
              </Form.Item>
              <Form.Item
                label="Đơn vị chịu trách nhiệm:"
                name="branchId"
                layout="vertical"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Đơn vị chịu trách nhiệm"
                  options={sLBranchId}
                />
              </Form.Item>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <Form.Item
                label="Khu vực:"
                name="regionId"
                layout="vertical"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Khu vực"
                  options={sLRegionId}
                />
              </Form.Item>

              <Form.Item
                label="Cấp độ xử lý:"
                name="processLevel"
                layout="vertical"
              >
                <Select
                  className="custom-page-css border rounded"
                  placeholder="Cấp độ xử lý"
                  options={dataProcessLevel}
                />
              </Form.Item>
            </div>
            {/* Nội dung */}
            <Form.Item
              label="Nội dung"
              name="complainDesc"
              layout="vertical"
            >
              <TextArea
                rows={4}
                placeholder="Nhập nội dung"
              />
            </Form.Item>

            {/* Giải pháp */}
            <Form.Item
              label="Giải pháp"
              name="solution"
              layout="vertical"
            >
              <TextArea
                rows={4}
                placeholder="Nhập giải pháp"
              />
            </Form.Item>


            <Form.Item
              label="Ghi chú:"
              name="note"
              layout="vertical"
            >
              <TextArea
                rows={4}
                placeholder="Nhập ghi chú"
              />
            </Form.Item>
            <Form.Item
              label="Lý do treo:"
              name="suspendReason"
              layout="vertical"
            >
              <TextArea
                rows={4}
                placeholder="Lý do treo"
              />
            </Form.Item>
            <Form.Item
              label="Ngày xử lý tiếp theo:"
              name="nextProcessDate"
              layout="vertical"
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || !docDate) {
                      return Promise.resolve();
                    }

                    if (value.isSame(docDate, "day") || value.isAfter(docDate, "day")) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      new Error("Ngày xử lý tiếp theo phải lớn hơn hoặc bằng ngày ghi nhận")
                    );
                  }
                })
              ]}
            >
              <DatePicker
                className="w-full custom-input-date"
                format="DD/MM/YYYY"
                disabled={!docDate}
              />
            </Form.Item>


          </div>
        </Modal>
      </ConfigProvider>
    </Form>
  )
}
export default ModalAddSupportHistoryV2
